/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_CreatedInputs */

const th_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างรายการแข่งขันแล้ว`)
};

const en_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event created.`)
};

const ja_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会を作成しました。`)
};

const zh_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛事已创建。`)
};

const es_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento creado.`)
};

const pt_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento criado.`)
};

const id_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara dibuat.`)
};

const fr_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement créé.`)
};

const tl_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagawa ang event.`)
};

const vi_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo sự kiện.`)
};

const ko_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트를 만들었습니다.`)
};

const de_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event angelegt.`)
};

const ru_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие создано.`)
};

const tr_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik oluşturuldu.`)
};

const it_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento creato.`)
};

const pl_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenie utworzone.`)
};

const uk_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подію створено.`)
};

const hi_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन बन गया।`)
};

const ar_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أُنشئت الفعالية.`)
};

const ms_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara dicipta.`)
};

const bn_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন তৈরি হয়েছে।`)
};

const zh_tw2_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事已建立。`)
};

const zh_hk2_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事已建立。`)
};

const ur_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ بن گیا۔`)
};

const fa_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رویداد ساخته شد.`)
};

const sw_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukio limefunguliwa.`)
};

const nl_event_created = /** @type {(inputs: Event_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement aangemaakt.`)
};

/**
* | output |
* | --- |
* | "Event created." |
*
* @param {Event_CreatedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_created = /** @type {((inputs?: Event_CreatedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_CreatedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_created(inputs)
	if (locale === "ja") return ja_event_created(inputs)
	if (locale === "zh") return zh_event_created(inputs)
	if (locale === "es") return es_event_created(inputs)
	if (locale === "pt") return pt_event_created(inputs)
	if (locale === "id") return id_event_created(inputs)
	if (locale === "fr") return fr_event_created(inputs)
	if (locale === "tl") return tl_event_created(inputs)
	if (locale === "vi") return vi_event_created(inputs)
	if (locale === "ko") return ko_event_created(inputs)
	if (locale === "de") return de_event_created(inputs)
	if (locale === "ru") return ru_event_created(inputs)
	if (locale === "tr") return tr_event_created(inputs)
	if (locale === "it") return it_event_created(inputs)
	if (locale === "pl") return pl_event_created(inputs)
	if (locale === "uk") return uk_event_created(inputs)
	if (locale === "hi") return hi_event_created(inputs)
	if (locale === "ar") return ar_event_created(inputs)
	if (locale === "ms") return ms_event_created(inputs)
	if (locale === "bn") return bn_event_created(inputs)
	if (locale === "zh-TW") return zh_tw2_event_created(inputs)
	if (locale === "zh-HK") return zh_hk2_event_created(inputs)
	if (locale === "ur") return ur_event_created(inputs)
	if (locale === "fa") return fa_event_created(inputs)
	if (locale === "sw") return sw_event_created(inputs)
	if (locale === "nl") return nl_event_created(inputs)
	return en_event_created(inputs)
});